/**
 * ConnectionQualityTracker: dentro da sala LiveKit, repassa a qualidade de conexão do atendente
 * (`local`) e do outro participante (`remote`) para o `tracker` (connectionQualityStats.js).
 * Não renderiza nada. Ao sair da sala, para de contar.
 */
import { useEffect } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { RoomEvent } from 'livekit-client';
import { isTranscriberIdentity } from './transcript/transcriptProtocol';

/** @param {{ tracker: ReturnType<typeof import('./connectionQualityStats').createConnectionQualityTracker> }} props */
export function ConnectionQualityTracker({ tracker }) {
    const room = useRoomContext();

    useEffect(() => {
        if (!room || !tracker) return undefined;
        const onChanged = (quality, participant) => {
            // A conexão do transcritor (servidor) não é a do contato: não entra na medição da pesquisa de qualidade.
            if (isTranscriberIdentity(participant?.identity)) return;
            tracker.record(participant?.isLocal ? 'local' : 'remote', quality);
        };
        room.on(RoomEvent.ConnectionQualityChanged, onChanged);
        return () => {
            room.off(RoomEvent.ConnectionQualityChanged, onChanged);
            tracker.pause();
        };
    }, [room, tracker]);

    return null;
}

export default ConnectionQualityTracker;
